export enum JobAcceptResult {
  Success = 1,
  PreviouslyAccepted = 2,
  TaskTypeRequirementNotMet = 3,
  TaskSchedulesMissing = 4,
  JobCancelled = 5,
  JobGrabDisabled = 6,
  InactiveOrganisation = 7,
  InactiveUser = 8,
  SuspendedOrganisation = 9,
}
